import { SITUACOES } from './fluxoDoBonusMoradia';

export const PERMISSAO_PARA_PRORROGAR_PRAZO =
  'BonusMoradiaControlarPrazoDeSolicitacoesReservadas';

export const PERMISSAO_POR_ACAO = {
  reservar: 'BonusMoradiaAnaliseDeSolicitacao',
  protocolarRecebimento: 'BonusMoradiaProtocolarRecebimentoDeDocumentacao',
  iniciarAnalise: 'BonusMoradiaIniciarAnaliseDeDocumentacao',
  marcarComoConforme: 'BonusMoradiaAnaliseDeDocumentacao',
  marcarComoInconforme: 'BonusMoradiaAnaliseDeDocumentacao',
  retomarAnalise: 'BonusMoradiaAnaliseDeCadastroInconforme',
  encaminharParaEmpenho: 'BonusMoradiaEncaminharParaEmpenho',
  registrarEmpenho: 'BonusMoradiaRegistrarEmpenho',
  gerarMinutaDoContrato: 'BonusMoradiaGerarMinutaDoContrato',
  encaminharAoGabinete: 'BonusMoradiaEncaminharParaAssinatura',
  encaminharAConstrutora: 'BonusMoradiaEncaminharParaAssinatura',
  registrarRetornoDaConstrutora:
    'BonusMoradiaRegistrarColetaDeAssinaturaConstrutora',
  registrarAssinatura: 'BonusMoradiaEncaminharParaPagamento',
  registrarPagamento: 'BonusMoradiaRegistrarPagamento',
};

export const PERMISSAO_DE_INDEFERIR_POR_SITUACAO = {
  [SITUACOES.SOLICITADO]: 'BonusMoradiaAnaliseDeSolicitacao',
  [SITUACOES.RESERVADO]: 'BonusMoradiaProtocolarRecebimentoDeDocumentacao',
  [SITUACOES.PRAZO_DOSSIE_VENCIDO]:
    'BonusMoradiaProtocolarRecebimentoDeDocumentacao',
  [SITUACOES.PRAZO_DOSSIE_PRORROGADO]:
    'BonusMoradiaProtocolarRecebimentoDeDocumentacao',
  [SITUACOES.PRAZO_DOSSIE_VENCIDO_PRORROGACAO]:
    'BonusMoradiaProtocolarRecebimentoDeDocumentacao',
  [SITUACOES.INCONFORME]: 'BonusMoradiaAnaliseDeCadastroInconforme',
};

export const CHAVE_DA_ACAO_DE_INDEFERIR = 'indeferir';

export function obterPermissaoDaAcao(chaveDaAcao, situacao) {
  if (chaveDaAcao === CHAVE_DA_ACAO_DE_INDEFERIR) {
    return PERMISSAO_DE_INDEFERIR_POR_SITUACAO[situacao] || null;
  }

  return PERMISSAO_POR_ACAO[chaveDaAcao] || null;
}



// WEBPACK FOOTER //
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/utils/permissoesDoBonusMoradia.js